/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { EvaluationUsage } from './EvaluationUsage.js';
import {
    EvaluationUsageFromJSON,
    EvaluationUsageFromJSONTyped,
    EvaluationUsageToJSON,
} from './EvaluationUsage.js';
import type { QARuleWithResult } from './QARuleWithResult.js';
import {
    QARuleWithResultFromJSON,
    QARuleWithResultFromJSONTyped,
    QARuleWithResultToJSON,
} from './QARuleWithResult.js';
import type { ScorecardMarker } from './ScorecardMarker.js';
import {
    ScorecardMarkerFromJSON,
    ScorecardMarkerFromJSONTyped,
    ScorecardMarkerToJSON,
} from './ScorecardMarker.js';
import type { ScorecardSectionWithResult } from './ScorecardSectionWithResult.js';
import {
    ScorecardSectionWithResultFromJSON,
    ScorecardSectionWithResultFromJSONTyped,
    ScorecardSectionWithResultToJSON,
} from './ScorecardSectionWithResult.js';

/**
 * 
 * @export
 * @interface QAResult
 */
export interface QAResult {
    /**
     * 
     * @type {number}
     * @memberof QAResult
     */
    points?: number;
    /**
     * 
     * @type {Array<QARuleWithResult>}
     * @memberof QAResult
     */
    rules?: Array<QARuleWithResult>;
    /**
     * 
     * @type {Array<ScorecardSectionWithResult>}
     * @memberof QAResult
     */
    sections?: Array<ScorecardSectionWithResult>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QAResult
     */
    flags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QAResult
     */
    messages?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof QAResult
     */
    state?: { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof QAResult
     */
    hiddenLedgerItems?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QAResult
     */
    shownLedgerItems?: Array<string>;
    /**
     * 
     * @type {EvaluationUsage}
     * @memberof QAResult
     */
    usage?: EvaluationUsage;
    /**
     * 
     * @type {Array<ScorecardMarker>}
     * @memberof QAResult
     */
    markers?: Array<ScorecardMarker>;
}

/**
 * Check if a given object implements the QAResult interface.
 */
export function instanceOfQAResult(value: object): boolean {
    return true;
}

export function QAResultFromJSON(json: any): QAResult {
    return QAResultFromJSONTyped(json, false);
}

export function QAResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): QAResult {
    if (json == null) {
        return json;
    }
    return {
        
        'points': json['points'] == null ? undefined : json['points'],
        'rules': json['rules'] == null ? undefined : ((json['rules'] as Array<any>).map(QARuleWithResultFromJSON)),
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(ScorecardSectionWithResultFromJSON)),
        'flags': json['flags'] == null ? undefined : json['flags'],
        'messages': json['messages'] == null ? undefined : json['messages'],
        'state': json['state'] == null ? undefined : json['state'],
        'hiddenLedgerItems': json['hiddenLedgerItems'] == null ? undefined : json['hiddenLedgerItems'],
        'shownLedgerItems': json['shownLedgerItems'] == null ? undefined : json['shownLedgerItems'],
        'usage': json['usage'] == null ? undefined : EvaluationUsageFromJSON(json['usage']),
        'markers': json['markers'] == null ? undefined : ((json['markers'] as Array<any>).map(ScorecardMarkerFromJSON)),
    };
}

export function QAResultToJSON(value?: QAResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'points': value['points'],
        'rules': value['rules'] == null ? undefined : ((value['rules'] as Array<any>).map(QARuleWithResultToJSON)),
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(ScorecardSectionWithResultToJSON)),
        'flags': value['flags'],
        'messages': value['messages'],
        'state': value['state'],
        'hiddenLedgerItems': value['hiddenLedgerItems'],
        'shownLedgerItems': value['shownLedgerItems'],
        'usage': EvaluationUsageToJSON(value['usage']),
        'markers': value['markers'] == null ? undefined : ((value['markers'] as Array<any>).map(ScorecardMarkerToJSON)),
    };
}

